export * from './trim-uom.dto'